import { render, staticRenderFns } from "./PackageForm.vue?vue&type=template&id=37089c8b"
import script from "./PackageForm.vue?vue&type=script&lang=js"
export * from "./PackageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports